function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.921 20.354a8.05 8.05 0 0 0 8-8 7.953 7.953 0 0 0-1.6-4.763l.612-.62a.93.93 0 0 0 .3-.666.846.846 0 0 0-.86-.852.906.906 0 0 0-.682.279l-.581.565a8.016 8.016 0 0 0-4.306-1.89v-.781a.895.895 0 1 0-1.789 0v.782a8 8 0 0 0 .9 15.946zm0-6.66a1.327 1.327 0 0 1-1.332-1.332 1.359 1.359 0 0 1 .72-1.177V7.459a.6.6 0 0 1 .6-.6.6.6 0 0 1 .612.6v3.733a1.305 1.305 0 0 1 .72 1.169 1.325 1.325 0 0 1-1.32 1.333z",
  transform: "translate(-4.921 -2.712)"
});

function SvgFilledTimer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 17.642",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledTimer);
export default __webpack_public_path__ + "static/media/filled_timer.da5aaa2e.svg";
export { ForwardRef as ReactComponent };